import { type ReactNode } from 'react';

import { BrandMark } from '@/app/layout/brand-mark';

interface AuthLayoutProps {
  title: string;
  description?: ReactNode;
  children: ReactNode;
}

/** Public authentication frame: brand panel + focused form column. */
export function AuthLayout({ title, description, children }: AuthLayoutProps) {
  return (
    <div className="grid min-h-dvh bg-background lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <aside className="relative hidden flex-col justify-between overflow-hidden bg-inverse p-10 lg:flex">
        <BrandMark tone="inverse" />
        <div className="max-w-sm space-y-3">
          <p className="text-2xl leading-snug font-bold tracking-tight text-inverse-foreground">
            Operaciones internas de SORAI en un solo lugar.
          </p>
          <p className="text-sm text-inverse-muted">
            Productos SaaS, clientes, facturación electrónica y trabajo del equipo.
          </p>
        </div>
        <p className="text-xs text-inverse-muted">
          Uso exclusivo del personal autorizado de SORAI.
        </p>
      </aside>

      <main className="flex items-center justify-center px-4 py-12 sm:px-8">
        <div className="w-full max-w-sm">
          <div className="mb-8 lg:hidden">
            <BrandMark />
          </div>
          <div className="mb-6 space-y-1.5">
            <h1 className="text-2xl font-bold tracking-tight text-foreground">{title}</h1>
            {description && <p className="text-sm text-muted-foreground">{description}</p>}
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
